import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import { renderMenuItem } from "./utils/renderItems";
import { ClassHelper, cn } from "../../utils";

import { DROPDOWN_SIZES } from "./consts";
import { DropdownProps } from "./types";
import { HeaderItem } from "./parts/HeaderItem";
import { FooterItem } from "./parts/FooterItem";

export const Dropdown = ({
  menuItems,
  header,
  footer,
  triggerElement,
  size = "s",
  asChild = false,
  side = "bottom",
  modal = false,
  disabled = false,
  className = "",
  open,
  onOpenChange,
}: DropdownProps) => {
  const dropdownContentStyle = ClassHelper(
    DROPDOWN_SIZES,
    {
      [size]: size,
      className,
    },
    false,
  );
  return (
    <div className={cn("qodo qodo-dropdown")}>
      <DropdownMenu modal={modal} open={open} onOpenChange={onOpenChange}>
        <DropdownMenuTrigger
          asChild={asChild}
          className="select-none outline-none flex items-center"
          disabled={disabled}
        >
          {triggerElement}
        </DropdownMenuTrigger>
        <DropdownMenuContent
          side={side}
          align="end"
          className={dropdownContentStyle}
        >
          <HeaderItem header={header} />
          {menuItems
            .filter(menuItem => !menuItem.isHidden)
            .map((menuItem, index) => renderMenuItem(menuItem, index))}
          <FooterItem footer={footer} />
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
